
export const fetchHomeContentData = async () => {
  try {
    const response = await fetch("/json/home-content.json");

    if (!response.ok) {
      throw new Error("Failed to fetch JSON data");
    }

    const data = await response.json();

    // return array in required format
    return data;
  } catch (error) {
    console.error("Error fetching content:", error);
    return [];
  }
};